import { useAppSelector } from '@/store';
import type { CloningProgress } from '@/store/slices/poc/cloneQueueSlice';

export function useCloningProgress(cid: string): CloningProgress | undefined {
  return useAppSelector((state) => {
    const { currentlyCloning, cloningProgress } = state.cloneQueue;
    if (currentlyCloning?.cid !== cid || cloningProgress === null) return undefined;
    return cloningProgress;
  });
}
